import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class AAUrlSerializer extends DefaultUrlSerializer {
  serialize(tree: UrlTree) {
    const [path, query] = super.serialize(tree).split('?');

    const newPath = path.replace(/[&]/g, encodeURIComponent);
    const newQuery = query ? '?' + query : '';

    return newPath + newQuery;
  }
}
